import React, { useEffect, useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import "../../../Pages/AdminScreens/AddHolidays/AddHolidays.css";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { toast } from "react-toastify";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
const AddHolidays = () => {
  const location = useLocation();

  const [addHoliday, setAddHoliday] = useState({
    HolidayName: "",
    Date: "",
    Day: "",
  });
  const AnnouncementToken = GetToken();
  const [errorDesignation, setErrorDesignation] = useState(false);
  const [Errordate, setErrordate] = useState(false);
  const [errorHolidayDay,setErrorHolidayDay] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const navigate=useNavigate();
  
  const validateFields = () => {
    if (!addHoliday?.HolidayName) {
      setErrorDesignation("holidayname");
      return false
    }
    if (!addHoliday?.Date) {
      setErrordate("holidayDate");
      return false
    }
    if (!addHoliday?.Day) {
      setErrorHolidayDay("holidayDay");
      return false;
    }
    return true;
  }

  const allHolidays = location.state?.allHolidays;
  useEffect(() => {
    if (allHolidays) {
      setAddHoliday({
        HolidayName: allHolidays?.HolidayName || "",
        Date: allHolidays?.FromDate?.split("T")[0] || "",
        Day: allHolidays?.Days || "",
      });
    }
  }, [allHolidays]);

  const handleAddHolday = () => {
    if (!validateFields()) return
    const data = {};
    data.HolidayName = addHoliday?.HolidayName;
    data.Fromdate = addHoliday?.Date;
    data.Days = addHoliday?.Day;
    if(allHolidays?.Id ){
      data.Id=allHolidays?.Id; 
    }
    
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${AnnouncementToken}`,
      },
      url: `${Apiurl()}/Holiday/SaveHoliday`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setAddHoliday({
            Day: "",
            Date: "",
            HolidayName: "",
          });
          setErrorDesignation("")
          setErrorHolidayDay("")
          navigate("/Adm/Holidays/AllHolidays") 
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleEidtHolday = () => {
    if (!validateFields()) return
    const data = {};
    data.Id = addHoliday.Id
    data.HolidayName = addHoliday?.HolidayName;
    data.Fromdate = addHoliday?.Date;
    data.Days = addHoliday?.Day;
    if(allHolidays?.Id ){
      data.Id=allHolidays?.Id; 
    }
    
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${AnnouncementToken}`,
      },
      url: `${Apiurl()}/Holiday/SaveHoliday`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setAddHoliday({
            Day: "",
            Date: "",
            HolidayName: "",
          });
          setErrorDesignation("")
          setErrorHolidayDay("")
          navigate("/Adm/Holidays/AllHolidays") 
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  // useEffect(()=>{
  //   handleEidtHolday()
  // },[])
  const handelclearState=()=>{
    setAddHoliday((emty)=>({
      ...emty,
      HolidayName: "",
      Date: "",
      Day: "",
    }))
    setErrorDesignation("")
    setErrordate("")
    setErrorHolidayDay("")
    // navigate("/Adm/Holidays/AllHolidays")
  }
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, [])
  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
 
          <>
            <div className= {showSidebar
     ?"main-container-of-all-employees-Attendance-AddHoliday"
     :"main-container-of-all-employees-page-new-Attendance-management"
            }>
              <div className="inner-container-of-all-employees-page-AddHoliday ">
                <div className="header-of-employees-page-AddHoliday row">
                  <div className="all-employee-Attendance-AddHoliday col">
                    <h4>Add Holiday</h4>
                  </div>
                  <div className="all-employees-Attendance-AddHoliday col">
                    <div className="home-icon-Attendance-AddHoliday">
                      
                      <BiHomeAlt className="home-icon-header-Attendance-AddHoliday" />
                    </div>
                    <div className="arrow-icon-Attendance-AddHoliday">
                      <MdKeyboardArrowRight />
                    </div>
                    <div className="employee-text-Attendance-AddHoliday">
                      <p>Holiday </p>
                    </div>
                    <div className="arrow-icon-Attendance-AddHoliday">
                      <MdKeyboardArrowRight />
                    </div>
                    <div className="all-employee-text-Attendance-AddHoliday">
                      <p>Add Holiday</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="body-part-outer-Attendance-AddHoliday">
                <div className="table-in-all-emplyee-Attendance-AddHoliday">
                  <div className="new-holiday-heading-add-AddHoliday padding-set">
                  </div>
                  <div>
                    
                    <div className="Addemployee-inputs-holidays ">
                      <FloatingLabelInput
                        label="Holiday Name*"
                        value={addHoliday?.HolidayName}
                        onChange={(e) =>
                          setAddHoliday({
                            ...addHoliday,
                            HolidayName: e?.target?.value,
                          })
                        }
                        onBlur={(e) => {
                          if (!e?.target?.value) {
                            setErrorDesignation("holidayname");
                          } else {
                            setErrorDesignation(false);
                          }
                        }}
                      />
                      {errorDesignation === "holidayname" &&
                        !addHoliday?.HolidayName ? (
                        <span className="contact_error-signup">
                          Holiday Name is required.
                        </span>
                      ) : null}
                    </div>
                    <div className="Addemployee-calender-holidays row">
                      <div className="holiday-date-from  col-6">
                        <label htmlFor="">Holiday Date</label>
                        <input
                          type="date"
                          value={addHoliday?.Date}
                          onChange={(e) =>
                            setAddHoliday({
                              ...addHoliday,
                              Date: e?.target?.value,
                            })
                          }
                          onBlur={(e) => {
                            if (!e?.target?.value) {
                              setErrordate("holidayDate");
                            } else {
                              setErrordate(false);
                            }
                          }}
                        />
                          {Errordate === "holidayDate" &&
                        !addHoliday?.Date ? (
                        <span className="contact-date">
                          Holiday date is required.
                        </span>
                      ) : null}
                      </div>
                     
                      <div className="Addemployee-inputs-holidays col-6">
                      <label htmlFor=""> </label>
                          <FloatingLabelInput
                            label="Day*"
                            value={addHoliday?.Day}
                            onChange={(e) =>
                              setAddHoliday({
                                ...addHoliday,
                                Day: e?.target?.value,
                              })
                            }
                            onBlur={(e) => {
                              if (!e?.target?.value) {
                                setErrorHolidayDay("holidayDay");
                              } else {
                                setErrorHolidayDay(false);
                              }
                            }}
                          />
                        {errorHolidayDay === "holidayDay" &&
                          !addHoliday?.Day ? (
                          <span className="contact_error-signup">
                            Holiday Day is required.
                          </span>
                        ) : null}
                      </div>
                    </div>
                   
                  </div>
                  <div className="save-button-in-setting-annoucement">
                    <button
                      className="save-button-in-setting-annoucement-button-one-add-holiday"
                      onClick={() => handleAddHolday()}
                    >
                      {allHolidays ? "Update" : "Submit"}
                    </button>
                    <button onClick={handelclearState} className="save-button-in-setting-annoucement-button-two-add-holiday  ">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        
      </div>
    </>
  );
};
export default AddHolidays;